import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationTransporteurs } from 'store/administration/administrationActions';

import { postTransporteur } from 'store/administration/administrationActions';
import { deleteTransporteur } from 'store/administration/administrationActions';

import AdministrationTransporteurs from './AdministrationTransporteurs';
import withLoader from 'components/Shared/withLoader';

const AdministrationTransporteursWithLoader = withLoader(AdministrationTransporteurs);

class AdministrationTransporteursContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addTransporteurDialogOpen: false,
            deleteTransporteurDialogOpen: false,
            transporteurToDelete: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationTransporteurs();
    }


    handleOpenAddDialog = () => {
        this.setState({
            addTransporteurDialogOpen: true
        });
    };
    handleCloseAddDialog = () => {
        this.setState({
            addTransporteurDialogOpen: false
        });
    };

    addTransporteur = async (transporteur) => {
        await this.props.postTransporteur(transporteur);
    };
             


    handleOpenDeleteDialog = (transporteurId) => {
        this.setState({
            deleteTransporteurDialogOpen: true,
            transporteurToDelete: this.props.transporteurs.find(x => x.id === transporteurId)
        });
    };
    handleCloseDeleteDialog = () => {
        this.setState({
            deleteTransporteurDialogOpen: false,
            transporteurToDelete: null
        });
    };
    

    deleteTransporteur = async (transporteurId) => {
        this.setState({
            deleteTransporteurDialogOpen: false
        });
        await this.props.deleteTransporteur(transporteurId);
    };

    render() {
        const { isLoading, transporteurs } = this.props;

        return (
            <AdministrationTransporteursWithLoader
                isLoading={isLoading}
                transporteurs={transporteurs}

                addTransporteurDialogOpen={this.state.addTransporteurDialogOpen}
                addTransporteur={this.addTransporteur}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}


                deleteTransporteurDialogOpen={this.state.deleteTransporteurDialogOpen}
                deleteTransporteur={this.deleteTransporteur}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                transporteurToDelete={this.state.transporteurToDelete}
            />
        );
    }
}

const mapStateToProps = state => ({
    isLoading: state.administration.transporteurs.isLoading,
    transporteurs: state.administration.transporteurs.items,
});



const mapDispatchToProps = {
    fetchAdministrationTransporteurs,
    postTransporteur,
    deleteTransporteur
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationTransporteursContainer);